<template>
	<div>
		<!--header-->
		<div class="m-wrap g-header">
			<div class="m-box">
				<div class="s-logo">
					<!-- <router-link to="/index"> <img src="../assets/images/logo.png" alt="logo"> </router-link> -->
					<a  @click="go('/')"><img src="../assets/images/logo_03.png" alt="logo"></a>
				</div>
				<div class="s-aside">
					<div class="s-nav s-pc">
						<ul>
							<li @click="go('/')" >
								<a>{{ $t('header.2') }}</a>		
							</li>
							<li  @click="$router.push('/mine')" >
								<a >{{ $t('indexzs.26') }}</a>		
							</li>
							<li  @click="go('#about')">	
								<a >{{ $t('header.3') }}</a>
							</li>
							<li @click="go('#Function')">
								<a >{{ $t('header.4') }}</a>
							</li>
							<li @click="go('#Appointment')">	
								<a >{{ $t('header.5') }}</a>
							</li>
							<li @click="go('#Mode')">	
								<a >{{ $t('header.6') }}</a>
							</li>
							<li  @click="go('#Safe')">
								<a >{{ $t('header.7') }}</a>
							</li>
						<!-- <li >
							<router-link  to="/mine">我的</router-link>
						</li> -->
						</ul>
					</div>
					<div class="n-icon ">
						<ul>
							<li class="but p18" >
								<button @click="login" v-if="user_addres==''">{{ $t('header.1') }}</button>
								<button @click="getSign" v-else>{{user_addres}}</button>
							</li>
							<li class="lange_b  p18" @click="show1 = !show1">
								<p > {{ $t('language.name') }}<b>&nbsp;∨&nbsp;</b></p>
								<div class="lange "  v-show="show1">
									<a @click="switch_the_language" >English</a>
									<br>
									<a @click="switch_the_language1" >简体中文</a>
								</div>
							</li>
						
						</ul>
					</div>
	 <div   :class="[ 'wap-menu s-wap',show2? 'on':'' ]"
							@click="show2 = !show2" > </div> 
				</div>
			</div>
		</div>


		<!--wap-sub-->
		<div class="wap-sub " v-show="show2">
			<div class="s-main">
				<!-- <div class="s-row" v-for="(item,index) in navlist" :key="index">
					<a :to="{path:item.link}">
						<h3><span>{{item.name}}</span><img src="../assets/img/right-arrow.svg" alt="right-arrow"> </h3>
					</a>
				</div> -->
				<div class="s-row" >
					<a @click="go('/')">
						<h3><span>{{ $t('header.2') }}</span><img src="../assets/img/right-arrow.svg" alt="right-arrow"> </h3>
					</a>
				</div>
				<div class="s-row" @click="show2 = !show2">
					<a @click="$router.push('/mine')" >
						<h3><span>{{ $t('indexzs.26') }}</span><img src="../assets/img/right-arrow.svg" alt="right-arrow"> </h3>
					</a>
				</div>
				<div class="s-row" @click="show2 = !show2">
					<a @click="goRule('about')" >
						<h3><span>{{ $t('header.3') }}</span><img src="../assets/img/right-arrow.svg" alt="right-arrow"> </h3>
					</a>
				</div>
				<div class="s-row" @click="show2 = !show2">
					<a @click="goRule('Function')" >
						<h3><span>{{ $t('header.4') }}</span><img src="../assets/img/right-arrow.svg" alt="right-arrow"> </h3>
					</a>
				</div>
				<div class="s-row" @click="show2 = !show2">
					<a @click="goRule('Appointment')" >
						<h3><span>{{ $t('header.5') }}</span><img src="../assets/img/right-arrow.svg" alt="right-arrow"> </h3>
					</a>
				</div>
				<div class="s-row" @click="show2 = !show2">
					<a @click="goRule('Mode')" >
						<h3><span>{{ $t('header.6') }}</span><img src="../assets/img/right-arrow.svg" alt="right-arrow"> </h3>
					</a>
				</div>
				<div class="s-row" @click="show2 = !show2">
					<a  @click="goRule('Safe')" >
						<h3><span>{{ $t('header.7') }}</span><img src="../assets/img/right-arrow.svg" alt="right-arrow"> </h3>
					</a>
				</div>
			<!-- <div class="s-row" >
				<router-link  to="/mine">
					<h3><span>{{ $t('header.7') }}</span><img src="../assets/img/right-arrow.svg" alt="right-arrow"> </h3>
				</router-link>
			</div> -->
				<!-- <div class="s-row">
					<div class="s-sub1">
						<van-dropdown-menu  >
						  <van-dropdown-item v-model="value1" :options="option1"  @change="changedeta()" />
						 
						</van-dropdown-menu>
						
					</div>
				</div> -->
			</div>
		</div>
		 <div class="tips" v-show="tips">
          <div>
            <p>敬请期待</p>
			<div class="close" @click="tips=false"></div>
          </div>
        </div>
	</div>
</template>

<script>
	export default {
		data() {

			return {
				show2: false,
				show1: false,
				nowIndex: 0,
				message: this.$t('language.name'),
				user_addres:"",
				tips:false,
				ison:true,	
				
				navlist:[{
						name:  this.$t('header.2') ,
						link: "/index",
						
					},
					{
						name: this.$t('header.3'),
						link: "#About",
						
					}, {
						name: this.$t('header.4'),
						link: "/iod",
						id:"2"
					},{
						name: this.$t('header.5'),
						link: "/mming"
					}, 
					{
						name: this.$t('header.6'),
						link: "/my"
					}
				],
				value1: 0,
				     
				      option1: [
				        { text:  "简体中文", value: 0 },
				        { text: 'English', value: 1 },
				       
				      ],

			}
		},
		mounted(){
			
			var self=this
			
			
			self.$metaMask.init().then(() => {
				// 初始化web3
				let web3 = self.$metaMask.getWeb3();
				// 遍历合约对象
				self.$metaMask.getContract(web3, self.$abi);
				console.log(self.$metaMask.getContract(web3, self.$abi))
				var time=setInterval(function(){
					console.log(self.$store.state.wallet.account)
					if(self.$store.state.wallet.account!=""){
						clearInterval(time)
						self.user_addres=self.addres_fun(self.$store.state.wallet.account)
						// self.getSign(self.$store.state.wallet.account)
					}else{
						self.user_addres=self.addres_fun(localStorage.getItem("addres"))
					}
				},200)
			})
			
		},
		methods: {
			 open_tips(){
				this.tips=true
			},
			close_tips(){
				this.tips=false
			},
			go(url){
				
				console.log(this.$route.name);
				
if(this.$route.name=='mine'){
	this.$router.push('/')
}else{
	window.location.href=url

}
				
			},
				// 获取用户信息
			getUserInfo: function() {
				let self = this
				if (self.$store.state.wallet.account) {
					self.$api.app.getUser(self.$store.state.wallet.account).then(res => {
					// console.log(res)
					self.$store.commit('SET_USER_INFO', res.data);
					self.user_addres=res.data
					
					}).catch(err => {
					console.log(err)
					})
				}
				},
				//获取签名
				async getSign(addres) {
					var self=this
					let web3 = self.$metaMask.getWeb3();
					const account = addres;
					web3.eth.personal.sign(web3.utils.fromUtf8("1"), account,(err, res) =>{
						console.log("签名后的数据：",res)
					})
				},
				//登录
				login(){
					this.$metaMask.init()
				},
				//处理地址，中间变成省略号
				addres_fun(addres){
					addres=addres.substr(0,6)+'******'+addres.substr(39,addres.split('').length);
					return addres
					// for(var i=0;i<addres.length;i++){
					// 	console.log(addres[i])
					// }
				},
				//锚点跳转
				   goRule(event) {
				     var ID = "#" + event;
					 console.log(this.$route);
					 if(this.$route.name=='mine'){
						this.$router.push('/')
					 }else{
				     document.querySelector(ID).scrollIntoView({
				       behavior: "smooth",
				       block: "center",
				       inline: "nearest",
				     });
					 }
				
				   },
			// 注3：增加语言切换函数
				switch_the_language() {
					
						this.$i18n.locale = 'en'
						this.$store.state.translate=true
						
				
					
				
					
					
				},
				switch_the_language1() {
					
						
						
				
						this.$i18n.locale = 'zh'
						this.$store.state.translate=false
				
					
					
				},
				
			}
		}
</script>
<style>

</style>
